import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Intercom } from '@capacitor-community/intercom';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-paywall',
  templateUrl: './paywall.component.html',
  styleUrls: ['./paywall.component.scss'],
})
export class PaywallComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit() {}

  openSupport() {
    // Intercom
    // If the platform is capacitor, use the Intercom plugin
    if (Capacitor.isNativePlatform()) {
      Intercom.displayMessenger();
    } else {
      //IntercomWeb('show');
    }
  }

  goHome() {
    // Navigate to the home page
    this.router.navigate(['/t/home']);
  }

  logout() {
    // Logout the user
    this.authService.logout();
    this.router.navigate(['/intro']);
  }

}
